import { QueryKey } from "@tanstack/react-query";

export const promotionQueryKeys = {
  all: () => ["promotion"] as QueryKey,
  list: (filters?: Readonly<{ [k: string]: any }>) =>
    [...promotionQueryKeys.all(), { filters }] as QueryKey,
  details: (promotionId?: number) =>
    [...promotionQueryKeys.all(), promotionId] as QueryKey,
};
